(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jenchante-category-entry"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-jenchante-category-prev], [data-jenchante-category-next]');
    if (!button) return;

    const section = button.closest('[data-jenchante-category-scroll]');
    const track = section && section.querySelector('[data-jenchante-category-track]');
    if (!track) return;

    const direction = button.matches('[data-jenchante-category-prev]') ? -1 : 1;
    track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
